/*

Parameters:

- breakpoints [array] required
- callback [function] required
- data [object]
- endDate [string]
- startDate [string]

## breakpoints: list of breakpoints, contains a window.matchMedia object and an image parameter name

## callback([imageUrl]): callback function

## data: json node with all the images urls, we use the breakpoint.parameter to search an image

## endDate: date string to use with moment.js
## startDate: date string to use with moment.js

*/

import moment from 'moment-timezone';
import { REFERENCE_TIMEZONE } from './constants';

export default function checkBackground(config) {
  const startDate = moment(
    config.startDate,
    'MM/DD/YYYY HH:mm',
  ).tz(REFERENCE_TIMEZONE);
  const endDate = moment(
    config.endDate,
    'MM/DD/YYYY HH:mm',
  ).tz(REFERENCE_TIMEZONE);
  const today = moment().tz(REFERENCE_TIMEZONE);

  function changeBackgroundMediaQuery(mediaQuery, imageParameter) {
    const imageUrl = config.data[imageParameter].url;

    if (imageUrl && today > startDate && today < endDate && mediaQuery.matches) {
      config.callback(imageUrl);
    } else if (!imageUrl && mediaQuery.matches) {
      config.callback('');
    }
  }

  config.breakpoints.forEach((breakpoint) => {
    breakpoint.matchMedia.addListener((mediaQuery) => {
      changeBackgroundMediaQuery(mediaQuery, breakpoint.parameter);
    });

    changeBackgroundMediaQuery(breakpoint.matchMedia, breakpoint.parameter);
  });
}
